import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import store, { loanActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { LoanApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { RefreshEvents } from '../../common/SharedEvents';
import { LoadPanel } from 'devextreme-react/load-panel';
import { handleAdminError, handleAdminSuccess } from '../../common/SharedFunctions';

const styles = {
    buttonMarginRight: { marginRight: '10px' },
    buttonContainer: {
        textAlign: 'right',
        borderTop: '2px solid silver',
        padding: '10px 10px',
    },
    form: { paddingLeft: '5px', paddingTop: '10px' },
    formRow: { marginBottom: '0' },
};

const DeleteLoanModal = () => {
    const { isOpen, loanId } = useSelector((state) => state.loan.deleteLoanModal);
    const { dispatch } = store;

    const [reason, set_reason] = useState('');
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [loadingMessage, set_loadingMessage] = useState('Loading...');

    const loanApi = new LoanApi.LoanApi(applicationInsights);
    const refreshEvents = new RefreshEvents();

    const _handleClose = () =>
        dispatch(
            loanActions.setDeleteLoanModal({
                deleteLoanModal: { isOpen: false },
            })
        );

    const deleteLoan = async (e) => {
        e.preventDefault();

        try {
            set_loadingMessage('Saving...');
            set_loadingOpen(true);

            const response = await loanApi.setLoanDeleted(loanId, reason);
            if (response.statusCode !== 200) {
                set_loadingOpen(false);
                return;
            }

            refreshEvents.dispatchRefreshEvent();

            handleAdminSuccess('Loan updated successfully and moved to Recycle Bin.');

            setTimeout(() => {
                _handleClose();
            }, 600);
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred. Please try again.');
        } finally {
            set_loadingOpen(false);
        }
    };

    useEffect(() => {
        set_loadingOpen(false);
        set_reason('');
    }, [isOpen, loanId]);

    return (
        <>
            <Dialog
                maxWidth='sm'
                open={isOpen}
                onClose={_handleClose}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex={-1}
                            role='dialog'
                            style={{ width: '425px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <form
                                    name='receiveAppraisalForm'
                                    onSubmit={(event) => deleteLoan(event)}
                                >
                                    <div>
                                        <div
                                            className='page-header'
                                            role='banner'
                                        >
                                            <h1 style={{ whiteSpace: 'nowrap' }}>Send to Recycle Bin</h1>
                                            <button
                                                type='button'
                                                className='close'
                                                data-dismiss='modal'
                                                aria-label='Close'
                                                onClick={_handleClose}
                                            >
                                                <span aria-hidden='true'>&times;</span>
                                            </button>
                                        </div>
                                        <div>
                                            <div
                                                style={styles.form}
                                                className={'standard-form'}
                                            >
                                                <div
                                                    className='row'
                                                    style={styles.formRow}
                                                >
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='reason'>Reason/Notes</label>
                                                        <textarea
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            rows={3}
                                                            id='reason'
                                                            value={reason}
                                                            onChange={(e) => set_reason(e.target.value)}
                                                            required={true}
                                                            placeholder='Enter a reason for removing this loan...'
                                                            maxLength={400}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ padding: '5px 5px' }}>
                                            <div
                                                className='button-footer'
                                                style={styles.buttonContainer}
                                            >
                                                <button
                                                    style={styles.buttonMarginRight}
                                                    type='submit'
                                                    className='button primary'
                                                >
                                                    Submit
                                                </button>
                                                <button
                                                    type='button'
                                                    className='button hollow'
                                                    data-dismiss='modal'
                                                    onClick={_handleClose}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </>
    );
};

export default DeleteLoanModal;
